/* ------------------------------------------------------------
   EcomIQ Sales Lander - Klaviyo popup triggers
   Any element carrying data-kl-form="FORM_ID" opens that Klaviyo
   onsite form instead of following its href. Bound once per page
   via delegation, so it also covers sections added later by the
   theme editor.
   ------------------------------------------------------------ */
(function () {
  if (window.__eiqKlBound) return;
  window.__eiqKlBound = true;

  function open(id) {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', id]);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var trigger = target.closest('[data-kl-form]');
    if (!trigger) return;
    var id = trigger.getAttribute('data-kl-form');
    if (!id) return;
    event.preventDefault();
    open(id);
  });
})();

/* ------------------------------------------------------------
   Optional suppression of unwanted floating widgets.

   Hides ONLY what is named in BLOCK_IDS or BLOCK_TEXT below.
   Nothing is hidden by default, and nothing inside .ee-frame
   (our own page markup) is ever touched, so this cannot hide a
   section, a CTA, our sticky bar or an embedded form.

   History worth keeping: this began as a whitelist that hid any
   Klaviyo form it did not recognise. That is the wrong default.
   It silently hid the How it works popup, and the symptom looked
   like a broken modal rather than a suppression. Never go back
   to hiding by default.

   BLOCK_IDS  preferred and durable. Klaviyo > Sign-up forms >
              open the form > the ID is in the URL.
   BLOCK_TEXT fallback when the ID is not to hand. Matches a
              widget's own visible text, case-insensitive, and
              only acts on genuinely floating elements. Stops
              working if the copy changes, which fails safe.
   ------------------------------------------------------------ */
(function () {
  if (window.__eiqKlSweepBound) return;
  window.__eiqKlSweepBound = true;

  var BLOCK_IDS = [];
  var BLOCK_TEXT = ['Stay in touch'];

  var MARK = 'data-eiq-hidden';

  function text(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function matchesText(el) {
    if (!BLOCK_TEXT.length) return false;
    var t = text(el);
    if (!t || t.length > 120) return false;
    for (var i = 0; i < BLOCK_TEXT.length; i++) {
      if (t.indexOf(BLOCK_TEXT[i].toLowerCase()) !== -1) return true;
    }
    return false;
  }

  function matchesId(el) {
    if (!BLOCK_IDS.length) return false;
    var cls = el.getAttribute('class') || '';
    for (var i = 0; i < BLOCK_IDS.length; i++) {
      if (cls.indexOf(BLOCK_IDS[i]) !== -1) return true;
    }
    return false;
  }

  // Walk up to the outermost floating ancestor, so the whole widget
  // goes rather than just its label.
  function floatingRoot(el) {
    var node = el, found = null, hops = 0;
    while (node && node !== document.body && hops < 12) {
      var pos;
      try { pos = window.getComputedStyle(node).position; } catch (e) { pos = ''; }
      if (pos === 'fixed' || pos === 'sticky') found = node;
      node = node.parentElement;
      hops++;
    }
    return found;
  }

  // True for anything that belongs to our own sections, including the
  // Shopify wrapper divs that sit outside .ee-frame.
  function isOurs(el) {
    if (!el.closest) return false;
    return !!(
      el.closest('.ee-frame') ||
      el.closest('[class*="eiq-lp-"]') ||
      el.closest('[class*="eiq-hiw-"]')
    );
  }

  function hide(el) {
    if (!el || el.getAttribute(MARK)) return;
    el.style.setProperty('display', 'none', 'important');
    el.setAttribute(MARK, '1');
  }

  function sweep() {
    if (!BLOCK_IDS.length && !BLOCK_TEXT.length) return;
    if (!document.body) return;

    var nodes;
    try {
      nodes = document.body.querySelectorAll('div,section,aside,form');
    } catch (e) {
      return;
    }

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute(MARK)) continue;
      // Never touch our own markup. .ee-frame covers the section's
      // contents; the OURS test also covers the Shopify section
      // wrappers, which sit OUTSIDE .ee-frame and are themselves
      // floating (the sticky topbar and the sticky CTA bar).
      if (isOurs(el)) continue;

      if (matchesId(el)) { hide(el); continue; }
      if (!matchesText(el)) continue;

      // Only act on genuinely floating widgets, so in-page copy that
      // happens to contain the phrase is left alone.
      var root = floatingRoot(el);
      if (root && !isOurs(root)) hide(root);
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      queued = false;
      sweep();
    }, 0);
  }

  sweep();
  document.addEventListener('DOMContentLoaded', sweep);
  window.addEventListener('load', sweep);

  if (window.MutationObserver && document.documentElement) {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  setTimeout(sweep, 1200);
  setTimeout(sweep, 3500);
  setTimeout(sweep, 8000);
})();
